<script setup>
import {ref} from "vue";
import AiChatModal from "@/components/aiReportingChat/AiReportingChatModal.vue";
import {stripPaste} from "@/helpers/string";
import {useStore} from "vue2-helpers/vuex";

const exampleQuestions = [
    'How many startups did we interact with last year?',
    'If we have met before, please provide notes related to <CompanyName>',
    'Who are all the companies we engaged with in last year?',
    'How many new companies did we engage with over the past 6 moths by month?'
];

const exampleQuestionsTravelers = [
    'Have we engaged with <CompanyName> before? If so, please include notes.',
    'Which <SolutionCategory> companies have we engaged with in 2026?',
    'Which companies have we engaged with the most in 2026?',
];

const store = useStore();
const chatModal = ref(null);
const question = ref('');
const questionInput = ref(null);

function openModal() {
    if (!question.value.trim()) {
        return;
    }
    chatModal.value.open(question);
    question.value = '';
    questionInput.value.textContent = '';
}

function populateQuestion(exampleQuestionNumber) {
    question.value = getExampleQuestion(exampleQuestionNumber);
    questionInput.value.textContent = question.value;
    questionInput.value.focus();
}

function getExampleQuestion(exampleQuestionNumber) {
    if (store.getters.isTravelersEnterprise) {
        return exampleQuestionsTravelers[exampleQuestionNumber];
    } else {
        return exampleQuestions[exampleQuestionNumber];
    }
}
</script>

<template>
    <div class="card card--bordered card--ai">
        <h5 class="heading5 heading5--secondary">What do you want to know?</h5>
        <div class="card--ai__search">
            <span
                ref="questionInput"
                role="textbox"
                contenteditable
                v-focus
                placeholder="Ask about startups or partnerships"
                class="card--ai__search__input"
                @paste.prevent="stripPaste"
                @input="question = $event.target.textContent"
                @keyup.enter.prevent="openModal"
            />
            <button class="card--ai__search__button" @click="openModal"></button>
        </div>
        <ul v-if="store.getters.isTravelersEnterprise" class="card--ai__list">
            <li class="card--ai__list__startup pointer" @click="populateQuestion(0)">{{getExampleQuestion(0)}}</li>
            <li class="card--ai__list__intelligence pointer" @click="populateQuestion(1)">{{getExampleQuestion(1)}}</li>
            <li class="card--ai__list__partner pointer" @click="populateQuestion(2)">{{getExampleQuestion(2)}}</li>
        </ul>

        <ul v-else class="card--ai__list">
            <li class="card--ai__list__startup pointer" @click="populateQuestion(0)">{{getExampleQuestion(0)}}</li>
            <li class="card--ai__list__ecosystem pointer" @click="populateQuestion(1)">{{getExampleQuestion(1)}}</li>
            <li class="card--ai__list__partner pointer" @click="populateQuestion(2)">{{getExampleQuestion(2)}}</li>
            <li class="card--ai__list__intelligence pointer" @click="populateQuestion(3)">{{getExampleQuestion(3)}}</li>
        </ul>
        <AiChatModal ref="chatModal"/>
    </div>
</template>

<style scoped>
.pointer {
    cursor: pointer;
}
.card--ai__search__input:empty::before {
    content: attr(placeholder);
    color: #999;
    pointer-events: none;
}
</style>
